import React from 'react';
export function Guarantee() {
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: 'rgb(10, 26, 20)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-140">
      <div className="mx-auto max-w-3xl text-center" data-id="element-141">
        {/* ÍCONO */}
        <div className="mb-4 text-[64px] leading-[64px]" data-id="element-142">🛡️</div>

        {/* TÍTULO */}
        <h2 className="text-3xl font-black leading-10 text-red-500 m-0 mb-4" data-id="element-143">
          GARANTÍA CINTURÓN NEGRO™ — 7 DÍAS
        </h2>

        {/* CAJA GARANTÍA */}
        <div className="mb-6 rounded-xl p-6 border-2 border-red-700 shadow-sm" style={{
        backgroundColor: 'rgb(20, 5, 5)'
      }} data-id="element-144">
          <p className="text-base leading-[24px] text-gray-300 m-0 mb-3" data-id="element-145">
            Descargás los 6 tomos. Revisás los 6 bonos. Los abrís, los leés y
            los empezás a implementar en tu dojo si querés.
          </p>
          <p className="text-base leading-[24px] text-gray-300 m-0 mb-4" data-id="element-146">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-2xl font-black text-red-500 m-0 mb-3" data-id="element-147">
            Te devolvemos el 100%.
          </p>
          <p className="text-lg font-bold text-white m-0" data-id="element-148">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        {/* TEXTO DE CONFIANZA */}
        <p className="text-xs leading-[20px] text-gray-500 m-0" data-id="element-149">
          La confianza que tenemos en el Megapack Artes Marciales nos permite
          hacer esa promesa sin dudar.
          <br data-id="element-150" />
          Más de 800 instructores de todo el país ya lo implementaron en sus
          dojos.
          <br data-id="element-151" />
          La tasa de devoluciones es menor al 1%.
        </p>
      </div>
    </section>;
}